import { nutrition } from "../omnia";
import { IDashboardService } from "../types";

export type CroppingInfo = ReturnType<typeof getCroppingInfo>[number]

export function getCroppingInfo(svc: IDashboardService) {

    const fieldSvc = svc.getFieldService();

    const cropping = fieldSvc.cropping.filter(c => c.currentYear).map(c => ({

        croppingId: c.croppingId,
        description: c.description,

        cropId: c.cropId,
        area: c.area,
        boundaryArea: c.hasBoundary ? c.cropping.BoundaryArea : null,
        manureSpredableArea: nutrition.getManureSpreadableArea(c.cropping, false),

        nutrition: {
            hasRequirements: c.cropping.HasNutritionRequirements,
        },

        field: {
            fieldId: c.fieldId,
            name: c.fieldName,
            description: c.description,
            manureSpredableArea: c.field.ManureSpreadArea,
            psorpCapacity: c.field.PSorpCapacity
        }

    }))

    return cropping;

}
